import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ReactNode, useContext } from 'react';
import ThemeContext from 'contexts/themeContext';
import Content from 'layout/Content/Content';
import FooterRoutes from 'layout/Footer/FooterRoutes';
import HeaderRoutes from 'layout/Header/HeaderRoutes';
import WrapperOverlay from 'layout/Wrapper/WrapperOverlay';

interface IWrapperContainerProps {
	children: ReactNode;
	className?: string;
}
export const WrapperContainer = ({ children, className, ...props }: IWrapperContainerProps) => {
	const { rightPanel } = useContext(ThemeContext);
	return (
		<div
			className={classNames('wrapper', { 'wrapper-right-panel-active': rightPanel }, className)}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}>
			{children}
		</div>
	);
};
WrapperContainer.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
WrapperContainer.defaultProps = {
	className: undefined,
};

const Wrapper = () => {
	return (
		<>
			<WrapperContainer>
				<HeaderRoutes />
				<Content />
				<FooterRoutes />
			</WrapperContainer>
			<WrapperOverlay />
		</>
	);
};

export default Wrapper;
